export default "__VITE_ASSET__DBaNSMfD__"